import './index.scss'
$(document).ready(function() {
    // 当页面滚动时显示或隐藏返回顶部按钮
   
 
    // 点击返回顶部按钮时的动作
    $('#backToTop').click(function() {
        $('html, body').animate({scrollTop: 0}, 800); // 滚动到页面顶部，持续时间为800毫秒
        return false; // 阻止默认行为（如果有的话）
    });
});